import * as React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { useSeo } from "../../hooks";

import LibraryShelf from "../../components/Library/LibraryShelf";
import TomeReader from "../../components/Library/TomeReader";
import {
    BlackMagicTomeIContent,
    BlackMagicTomeIIContent,
    OnMagicUsersContent,
    HistoricalMythologyTomeIContent,
    HistoricalMythologyTomeIIContent,
    HistoricalMythologyTomeIIIContent,
    HistoricalMythologyTomeIVContent,
} from "../../components/Library/tomeContent";

const BrigobaenLibraryPage: React.FunctionComponent = () => {
    useSeo({
        title: "Brigobaen Library — Oberin",
        description:
            "The Brigobaen Library — a collection of lore, histories, and arcane knowledge from the world of Oberin. Read tomes on Black Magic, magic users, and historical mythology.",
        canonical: "https://www.oberin.be/library",
        robots: "index,follow",
        twitterCard: "summary",
    });

    return (
        <React.Fragment>
            <h1 className="sr-only">Brigobaen Library</h1>
            <Switch>
                <Route exact path="/library">
                    <LibraryShelf />
                </Route>
                <Route path="/library/black-magic-tome-i">
                    <TomeReader tomeId="black-magic-tome-i">
                        <BlackMagicTomeIContent />
                    </TomeReader>
                </Route>
                <Route path="/library/black-magic-tome-ii">
                    <TomeReader tomeId="black-magic-tome-ii">
                        <BlackMagicTomeIIContent />
                    </TomeReader>
                </Route>
                <Route path="/library/on-magic-users">
                    <TomeReader tomeId="on-magic-users">
                        <OnMagicUsersContent />
                    </TomeReader>
                </Route>
                <Route path="/library/historical-mythology-tome-i">
                    <TomeReader tomeId="historical-mythology-tome-i">
                        <HistoricalMythologyTomeIContent />
                    </TomeReader>
                </Route>
                <Route path="/library/historical-mythology-tome-ii">
                    <TomeReader tomeId="historical-mythology-tome-ii">
                        <HistoricalMythologyTomeIIContent />
                    </TomeReader>
                </Route>
                <Route path="/library/historical-mythology-tome-iii">
                    <TomeReader tomeId="historical-mythology-tome-iii">
                        <HistoricalMythologyTomeIIIContent />
                    </TomeReader>
                </Route>
                <Route path="/library/historical-mythology-tome-iv">
                    <TomeReader tomeId="historical-mythology-tome-iv">
                        <HistoricalMythologyTomeIVContent />
                    </TomeReader>
                </Route>
                <Redirect to="/library" />
            </Switch>
        </React.Fragment>
    );
};

export default BrigobaenLibraryPage;
